import {
  ArrowDownIcon as ArrowDown,
  ArrowLeftIcon as ArrowLeft,
  ArrowPathIcon as ArrowPath,
  ArrowRightIcon as ArrowRight,
  ArrowsPointingOutIcon as ArrowsPointingOut,
  ArrowTopRightOnSquareIcon as ArrowTopRightOnSquare,
  BanknotesIcon as Banknotes,
  Bars3Icon as Bars3,
  BoltIcon as Bolt,
  BookmarkSquareIcon as BookmarkSquare,
  BookOpenIcon as BookOpen,
  BriefcaseIcon as Briefcase,
  BuildingLibraryIcon as BuildingLibrary,
  CalendarIcon as Calendar,
  ChartBarIcon as ChartBar,
  ChartBarSquareIcon as ChartBarSquare,
  ChartPieIcon as ChartPie,
  ChatBubbleLeftRightIcon as ChatBubbleLeftRight,
  CheckIcon as Check,
  CheckBadgeIcon as CheckBadge,
  ChevronDownIcon as ChevronDown,
  ChevronLeftIcon as ChevronLeft,
  ChevronRightIcon as ChevronRight,
  ChevronUpIcon as ChevronUp,
  CircleStackIcon as CircleStack,
  ClockIcon as Clock,
  Cog8ToothIcon as Cog8Tooth,
  ComputerDesktopIcon as ComputerDesktop,
  CubeIcon as Cube,
  CurrencyDollarIcon as CurrencyDollar,
  DocumentIcon as Document,
  FingerPrintIcon as FingerPrint,
  GlobeAltIcon as GlobeAlt,
  InformationCircleIcon as InformationCircle,
  LightBulbIcon as LightBulb,
  LinkIcon as Link,
  MagnifyingGlassIcon as MagnifyingGlass,
  MegaphoneIcon as Megaphone,
  MoonIcon as Moon,
  NewspaperIcon as Newspaper,
  PlusIcon as Plus,
  PresentationChartLineIcon as PresentationChartLine,
  QuestionMarkCircleIcon as QuestionMarkCircle,
  ReceiptPercentIcon as ReceiptPercent,
  ScaleIcon as Scale,
  ShareIcon as Share,
  ShieldCheckIcon as ShieldCheck,
  SparklesIcon as Sparkles,
  Squares2X2Icon as Squares2X2,
  StarIcon as Star,
  SunIcon as Sun,
  TvIcon as Tv,
  UserIcon as User,
  UserGroupIcon as UserGroup,
  WindowIcon as Window,
  XMarkIcon as XMark,
} from "@heroicons/react/24/outline";
import * as HeroIconsOutlineIcons from "@heroicons/react/24/outline";
import { Command, Globe } from "lucide-react";

import { cn } from "@/lib/utils";

export type CustomIconProps = React.PropsWithoutRef<
  React.SVGProps<SVGSVGElement>
>;

export const Icons = {
  ...HeroIconsOutlineIcons,
  Logo: Command,
  ArrowDown,
  ArrowLeft,
  ArrowPath,
  ArrowRight,
  ArrowTopRightOnSquare,
  ArrowsPointingOut,
  Banknotes,
  Bars3,
  Bolt,
  BookOpen,
  BookmarkSquare,
  Briefcase,
  BuildingLibrary,
  Calendar,
  ChartBar,
  ChartBarSquare,
  ChartPie,
  ChatBubbleLeftRight,
  Check,
  CheckBadge,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  CircleStack,
  Clock,
  Cog8Tooth,
  ComputerDesktop,
  Cube,
  CurrencyDollar,
  Document,
  FingerPrint,
  GlobeAlt,
  InformationCircle,
  LightBulb,
  Link,
  MagnifyingGlass,
  Megaphone,
  Moon,
  Newspaper,
  Plus,
  PresentationChartLine,
  QuestionMarkCircle,
  ReceiptPercent,
  Scale,
  Share,
  ShieldCheck,
  Sparkles,
  Squares2X2,
  Star,
  Sun,
  Tv,
  User,
  UserGroup,
  Window,
  XMark,
  // Non-heroicons
  Globe,
  // custom icons
  Banknotes2: ({ className, ...props }: CustomIconProps) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("stroke-grey-400", className)}
      {...props}
    >
      <path
        d="M17 9V7C17 5.89543 16.1046 5 15 5H5C3.89543 5 3 5.89543 3 7V13C3 14.1046 3.89543 15 5 15H7M9 19H19C20.1046 19 21 18.1046 21 17V11C21 9.89543 20.1046 9 19 9H9C7.89543 9 7 9.89543 7 11V17C7 18.1046 7.89543 19 9 19ZM16 14C16 15.1046 15.1046 16 14 16C12.8954 16 12 15.1046 12 14C12 12.8954 12.8954 12 14 12C15.1046 12 16 12.8954 16 14Z"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Package: ({ className, ...props }: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      className={cn("stroke-grey-400", className)}
      {...props}
    >
      <path
        d="M21 7.5L12 2.25L3 7.5M21 7.5L12 12.75M21 7.5V16.5L12 21.75M3 7.5L12 12.75M3 7.5V16.5L12 21.75M12 12.75V21.75"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 5L17 10.25V13.5"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
} as const;
